import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Messages } from 'primereact/messages';

const TosterService = forwardRef((props, ref) => {
    const msgs = useRef(null);
    useImperativeHandle(ref, () => ({
        
        success: (message) => {
            msgs.current.show({ severity: 'success', detail: message, life:8000});
        },
        info: (message) => {
            msgs.current.show({ severity: 'info', detail: message, life:8000 });
        },
        warn: (message) => {
            msgs.current.show({ severity: 'warn', detail: message, life:8000 });
        },
        error: (message) => {
            msgs.current.show({ severity: 'error', detail: message, life:8000 });
        },
        
    }));

    return (
        <div>
            <Messages ref={msgs} className='toater-box' />
        </div>
    );
    
});

export default TosterService;
//sticky:true